import React from "react";
import {
	StyleSheet,
	View,
} from "react-native";

const styles = StyleSheet.create({
	blockView: {
	}
});

export default function BlockView(props) {
	const styleList = [styles.blockView];
	const children = props.children;

	const otherStyles = props.style;
	styleList.push(otherStyles);

	return (
		<View style={styleList}>
			{children}
		</View>
	);
}
